// extracted by mini-css-extract-plugin
export default {"root":"MT_GCLsfe_NY9nJxADwK","label":"yCjJKjtKnFRIQcEJv4I2","placeHolderShimmer":"IJRphZ1LW3tgI41g0Ueo"};